export const assetType = {
  real_estate: "real_estate",
  bank: "bank",
  business: "business",
  vehicle: "vehicle",
  superannuation: "superannuation",
  shares_investments: "shares_investments",
  investments: "investments",
  overseas: "overseas",
  miscellaneous: "miscellaneous",
  personal_and_household: "personal_and_household",
  life_insurance: "life_insurance",
  retirement_fund: "retirement_fund",
  trust: "trust",
  furniture_and_personal: "furniture_and_personal"
};

export const debtType = {
  mortgage: "mortgage",
  credit_card: "credit_card",
  miscellaneous_debt: "miscellaneous_debt",
  business_debt: "business_debt",
  hire_purchase_lease_debt: "hire_purchase_lease_debt"
};

export const debtTypeOptions = [
  {
    label: "Car Loan",
    value: "car_loan"
  },
  {
    label: "Credit Card",
    value: "credit_card"
  },
  {
    label: "Overseas Debt",
    value: "overseas_debt"
  },
  {
    label: "Hire Purchase",
    value: "hire_purchase"
  },
  {
    label: "Tax Debt",
    value: "tax_debt"
  },
  {
    label: "Miscellaneous",
    value: "miscellaneous"
  }
];

export const assetTypeOptions = [
  {
    label: "Real Estate",
    value: "real_estate"
  },
  {
    label: "Bank Account",
    value: "bank"
  },
  {
    label: "Vehicle",
    value: "vehicle"
  },
  {
    label: "Stock/Investment",
    value: "stock"
  },
  {
    label: "Business",
    value: "business"
  },
  {
    label: "Household Furniture",
    value: "furniture"
  },
  {
    label: "Miscellaneous",
    value: "miscellaneous"
  },
  {
    label: "Superannuation",
    value: "superannuation"
  }
];

export const entityOptions = [
  { label: "Company", value: "company" },
  { label: "Sole Trader", value: "sole_trader" },
  { label: "Partnership", value: "partnership" },
  { label: "Trust", value: "trust" }
];
